import styled from 'styled-components';

import ArrowsButtonRightMin from '@/components/atom/icon/Arrow/ArrowsButtonRightMin';
import { SelectedDiagnosisSlot } from '@/components/templates/doctor/detail/useDoctorDetailViewModel';
import theme from '@/styles/theme';
import { BookingScheduleStatus, BookingScheduleTypeVo, DoctorDetail } from '@/types/doctor';

import DiagnosisSlotBottomSheet from './DiagnosisSlotBottomSheet';

interface Props {
  doctorDetail: DoctorDetail;
  isOpenedDiagnosisSlotBottomSheet: boolean;
  selectedDiagnosisSlot?: SelectedDiagnosisSlot;
  onClickDiagnosisSlotInSummary: (selectedDiagnosisSlot: SelectedDiagnosisSlot) => void;
  onClickDiagnosisSlotSelectBox: () => void;
  onChangeDiagnosisSlotBottomSheet: () => void;
  onChangeDiagnosisSlot: (selectedDiagnosisSlot: SelectedDiagnosisSlot) => void;
  requestTreatmentWithSlot: () => void;
}

const DoctorDiagnosisSchedules = ({
  doctorDetail,
  isOpenedDiagnosisSlotBottomSheet,
  selectedDiagnosisSlot,
  onClickDiagnosisSlotInSummary,
  onClickDiagnosisSlotSelectBox,
  onChangeDiagnosisSlotBottomSheet,
  onChangeDiagnosisSlot,
  requestTreatmentWithSlot,
}: Props) => {
  const todaySchedules = doctorDetail.diagnosisBookingSchedules[0];

  const isTodayBookable = todaySchedules.status === BookingScheduleStatus.Bookable;

  const availableSchedules = isTodayBookable
    ? doctorDetail.diagnosisBookingSchedules[0]
    : doctorDetail.diagnosisBookingSchedules[1];
  return (
    <Wrapper>
      <SelectBox onClick={onClickDiagnosisSlotSelectBox}>
        <DiagnosisInfo isTodayBookable={isTodayBookable}>
          {isTodayBookable ? '오늘' : '내일'} 예약{' '}
          <span>
            {isTodayBookable
              ? `${doctorDetail.bookingInfo.todayKickoffTime} ~
              ${doctorDetail.bookingInfo.todayCutoffTime}`
              : `${doctorDetail.bookingInfo.tomorrowKickoffTime} ~
              ${doctorDetail.bookingInfo.tomorrowCutoffTime}`}
          </span>
        </DiagnosisInfo>
        <ArrowsButtonRightMin color={theme.color.gray600} />
      </SelectBox>
      <SlotWrapper>
        {availableSchedules.schedules.map(
          (schedule) =>
            schedule.bookingStatus === BookingScheduleTypeVo.Bookable && (
              <Slot
                key={schedule.startTimeSlot.value}
                onClick={() =>
                  onClickDiagnosisSlotInSummary({
                    targetDate: availableSchedules.targetDate,
                    startTimeSlotValue: schedule.startTimeSlot.value,
                    endTimeSlotValue: schedule.endTimeSlot.value,
                    bookingStatus: schedule.bookingStatus,
                  })
                }
              >
                {schedule.startTimeSlot.displayTime}
              </Slot>
            )
        )}
      </SlotWrapper>
      <DiagnosisSlotBottomSheet
        isOpened={isOpenedDiagnosisSlotBottomSheet}
        onClose={onChangeDiagnosisSlotBottomSheet}
        bookingSchedules={doctorDetail.diagnosisBookingSchedules}
        selectedDiagnosisSlot={selectedDiagnosisSlot}
        onChangeDiagnosisSlot={onChangeDiagnosisSlot}
        requestTreatmentWithSlot={requestTreatmentWithSlot}
      />
    </Wrapper>
  );
};

export default DoctorDiagnosisSchedules;

const Wrapper = styled.div``;

const SelectBox = styled.div`
  padding: 13px 16px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 24px;

  ${({ theme }) => `
    border: 1px solid ${theme.color.gray100};
    
    &:hover {
      cursor: pointer;
    }
    // 색상 확인 필요
    &:active {
      background: ${theme.color.gray10};
    }
  `};
`;

const DiagnosisInfo = styled.div<{ isTodayBookable: boolean }>`
  display: flex;
  gap: 8px;
  align-items: center;

  ${({ theme }) => theme.typography.UI15SB}
  ${({ theme, isTodayBookable }) => {
    switch (isTodayBookable) {
      case true: {
        return `
          color: ${theme.color.green700};
        `;
      }
      default: {
        return `
          color: ${theme.color.primary600};
        `;
      }
    }
  }}
    span {
    ${({ theme }) => theme.typography.UI13M}
    color: ${({ theme }) => theme.color.gray200}
  }
`;

const SlotWrapper = styled.div`
  display: flex;
  margin-top: 12px;
  gap: 8px;
  overflow: scroll;
  padding: 0 24px;
`;

const Slot = styled.div`
  padding: 8px 12px;
  align-items: center;
  justify-content: center;
  border-radius: 40px;

  ${({ theme }) => `
    ${theme.typography.UI14M};
    color: ${theme.color.gray600};
    background: ${theme.color.gray30};

    &:hover {
      cursor: pointer;
    }

    // 색상 확인 필요
    &:active {
      background: ${theme.color.gray20};
    }
  `};
`;
